import {
  LegalLayout,
  Section,
  SubList,
} from "../components/legal/LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout
      title="Cookie Policy"
      updated="August 11, 2026"
      pageTestId="page-cookies"
    >
      <Section title="1. What this policy covers">
        <p>
          This Cookie Policy explains how IVORY PULSE SRL ("Ivory Pulse",
          "we") uses cookies and similar technologies — such as local
          storage and session storage — on ivory-pulse.com. It should be
          read together with our{" "}
          <a
            className="underline decoration-white/30 hover:decoration-white"
            href="/privacy"
          >
            Privacy Policy
          </a>
          .
        </p>
      </Section>

      <Section title="2. Strictly necessary technologies">
        <p>
          These are required for the website to function and cannot be
          switched off in our systems. They do not track you across other
          websites.
        </p>
        <SubList
          items={[
            "Session storage for the live voice demo — a short-lived demo session identifier so a conversation keeps its context while you stay on the page.",
            "Local functionality state — small values that remember interface choices during your visit.",
          ]}
        />
      </Section>

      <Section title="3. Analytics">
        <p>
          We use a privacy-focused product analytics service (PostHog) to
          understand, in aggregate, how visitors use the site — for example,
          which sections are read and where visitors drop off. This helps us
          improve the website. The service may set cookies or use local
          storage to distinguish visits.
        </p>
        <SubList
          items={[
            "Analytics data is used in aggregate to improve the site.",
            "We do not use analytics to build advertising profiles.",
            "Analytics identifiers are not linked to your waitlist email unless you explicitly identify yourself.",
          ]}
        />
      </Section>

      <Section title="4. What we do not do">
        <SubList
          items={[
            "No advertising or retargeting cookies.",
            "No sale of personal data.",
            "No cross-site tracking networks.",
            "No social-media tracking pixels.",
          ]}
        />
      </Section>

      <Section title="5. Managing cookies">
        <p>
          You can control and delete cookies through your browser settings —
          including blocking them entirely. Most browsers also offer a
          private/incognito mode that discards cookies when the window is
          closed. Blocking analytics does not affect your ability to browse
          the site or join the waitlist.
        </p>
        <p>
          Guides for common browsers: Safari (Preferences → Privacy), Chrome
          (Settings → Privacy and security), Firefox (Settings → Privacy
          &amp; Security), Edge (Settings → Cookies and site permissions).
        </p>
      </Section>

      <Section title="6. Changes to this policy">
        <p>
          If our use of cookies changes — for example, when payments open —
          we will update this page and revise the "Last updated" date above.
          Material changes will be highlighted on the site.
        </p>
      </Section>

      <Section title="7. Contact">
        <p>
          Questions about this policy? Email{" "}
          <a
            className="underline decoration-white/30 hover:decoration-white"
            href="mailto:contact@ivory-pulse.com"
          >
            contact@ivory-pulse.com
          </a>
          . To exercise privacy rights (access, deletion, correction), see
          our{" "}
          <a
            className="underline decoration-white/30 hover:decoration-white"
            href="/privacy"
          >
            Privacy Policy
          </a>
          .
        </p>
      </Section>
    </LegalLayout>
  );
}
